import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    page: 1,
    searchWord: '',
    statusFilter: '',
    sortFilter: 'po_number',
    sortAscending: true,
  },
}

const purchaseOrdersPageSlice = createSlice({
  name: 'purchaseOrdersPage',
  initialState,
  reducers: {
    updateFilters: (state, action) => {
      state.filters = action.payload
    },
    resetFilters: (state) => {
      state.filters = initialState.filters
    },
  },
})

export const { updateFilters, resetFilters } = purchaseOrdersPageSlice.actions
export default purchaseOrdersPageSlice.reducer 